import { PayloadAction } from '@reduxjs/toolkit';
import { AppState } from 'src/store/app/types';

const showPopupReducer = (state: AppState, action: PayloadAction<string>) => {
  state.activePopup = action.payload;
};

export default showPopupReducer;
